import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Sunidhi Singh',
    title: "Web Developer",
    desciption:"A confident, passionate, determined, and self-taught individual, seeking various opportunities to explore and research in the area of computer science.",
    image: 'https://avatars.githubusercontent.com/u/96500508?v=4',
    resumePdf: resume
}
